// Privacyrechten (0036). Engelse tegenhanger van privacyRights.nl.ts.
export const appPrivacyRightsEn = {
    title: 'Your data',
    intro: 'Download everything, remove someone from the family or delete the family board. It is your data.',
    entry: 'Your data',
    entryBody: 'Download everything, remove someone from the family, delete the family board.',
    exportTitle: 'Download everything',
    exportBody: 'One ZIP file with everything about your family: members, calendar, tasks, food, messages, details about photos and the choices under What suits our family. With a readable summary.',
    exportOwnerOnly: 'Only the owner of the family board can download everything.',
    exportStart: 'Prepare download',
    exportPending: 'We are making the file. This usually takes less than a minute.',
    exportReady: 'Ready · {size} · available until {time}',
    exportOnce: 'You can download the file once. After that we delete it.',
    exportDownload: 'Download',
    exportDownloaded: 'Downloaded on {time}',
    exportExpired: 'Expired on {time}',
    exportFailed: 'We could not make the file. Please try again.',
    exportAgain: 'Prepare again',
    exportMailed: 'All parents get an e-mail that a download is ready.',
    exportStarted: 'We are making the file',
    exportSaved: 'The file is in your downloads',
    mineTitle: 'Only your own data',
    mineBody: 'Your own data and the family profile that applies to you, as a file (JSON).',
    mineButton: 'Download my data',
    removeTitle: 'Remove someone from the family',
    removeBody: 'For example a child who moved out or an ex-partner. You do this under Family: open the person and choose Remove from family.',
    removeToMembers: 'Go to Family',
    removeButton: 'Remove from family',
    removeConfirmTitle: 'Remove {name} from the family?',
    removeConfirmNow: '{name} disappears from the app and the board right away. If {name} has their own login, it no longer works for this family.',
    removeConfirmLater: 'You can undo this for 7 days. After that we make {name} anonymous: the name becomes “Former family member”, photo, date of birth and special data (faith, health, school) are removed, as are future events and tasks. What already happened stays, without a name.',
    removeConfirmProfile: 'Their own choices under What suits our family and the weather are removed right away and do not come back when you undo.',
    removeConfirmButton: 'Remove from family',
    removeButtonHouse: 'Remove from the home',
    removeConfirmTitleHouse: 'Remove {name} from the home?',
    removeConfirmNowHouse: '{name} disappears from the app and the board right away. If {name} has their own login, it no longer works for this home.',
    removeConfirmLaterHouse: 'You can undo this for 7 days. After that we make {name} anonymous: the name becomes “{former}”, photo and personal data are removed, as are future events and tasks. What already happened (expenses too) stays, without a name.',
    removeConfirmProfileHouse: 'Choices {name} made (such as food and the weather) are removed right away and do not come back when you undo.',
    removeConfirmButtonHouse: 'Remove from the home',
    removeConfirmAnywayHouse: 'Remove from the home anyway',
    removedHouse: '{name} has been removed from the home',
    removeConfirmLinks: 'Calendar links {name} made (Google, Outlook or Apple Calendar) stop right away.',
    removeConfirmDevices: '{name} paired these tablets. They keep working until you unpair them:',
    removeUnpairDevice: 'Unpair tablet',
    removeDevicePaired: 'paired on {date}',
    removeDeviceUnpaired: '{name} is unpaired',
    removed: '{name} has been removed from the family',
    removedListTitle: 'Removed from the family',
    removedUntil: 'You can undo this until {time}',
    removedHadLogin: 'Login revoked',
    undo: 'Undo',
    undone: '{name} is back in the family',
    undoneNoLogin: '{name} is back in the family. The login could not come back; please invite again.',
    errorIsOwner: 'The owner cannot be removed from the family.',
    errorIsSelf: 'You cannot remove yourself from the family.',
    errorNeedsOwner: 'Only the owner can remove another parent from the family.',
    errorWindowClosed: 'The 7 days are over; undo is no longer possible.',
    errorAlreadyRemoved: 'This person has already been removed from the family.',
    errorDeletionUnavailable: 'Deleting is not possible right now. Nothing has been scheduled; try again later or email us.',
    errorConfirmName: 'The name does not match. Type the name of your family board exactly.',
    errorExportGone: 'This file is no longer available. Prepare a new download.',
    zipHint: 'Everything as one ZIP with a readable summary:',
    deleteTitle: 'Delete the family board',
    deleteBody: 'Everything about your family is erased: calendar, tasks, food, messages, photos and settings. You have 30 days to change your mind.',
    deleteOwnerOnly: 'Only the owner can delete the family board.',
    deleteButton: 'Delete family board…',
    deleteConfirmTitle: 'Delete the family board?',
    deletePoints: [
        'In 30 days we erase everything of {household}. It cannot be brought back after that.',
        'Until that day you can stop it with Do not delete.',
        'Until then the tablets show a calm notice, and they stop afterwards.',
        'All parents get an e-mail, now and when everything is erased.',
    ],
    deleteExportFirst: 'Download everything first?',
    deleteExportFirstBody: 'Make a copy before you delete. You can also do this later, until the day itself.',
    deleteTypeName: 'Type the name of your family board to confirm',
    deleteTypeNameHint: 'Exactly: {household}',
    deleteConfirmButton: 'Delete in 30 days',
    deleteScheduled: 'The family board will be deleted on {date}',
    deleteScheduledBody: 'Until that day everything keeps working. After that we erase everything and all parents get an e-mail.',
    deleteScheduledByAdmin: 'Scheduled by AMUMIN, at your request.',
    cancelDelete: 'Do not delete',
    cancelled: 'The family board stays',
    banner: 'This family board will be deleted on {date}.',
    bannerOwner: 'Do not delete',
    bannerOthers: 'Only the owner can stop this.',
    bannerMore: 'Learn more',
    formerMember: 'Former family member',
    formerMemberShared: 'Former housemate',
    formerMemberResident: 'Former resident',
    summary: {
        title: 'Data of {household}',
        intro: 'This is all the data of your family board on {date}, as AMUMIN keeps it. Every part is in its own JSON file; you can open it with a text editor or import it into another program.',
        fileHeader: 'File',
        whatHeader: 'What is in it',
        countHeader: 'Rows',
        membersTitle: 'Members',
        memberFormer: 'former family member',
        memberArchived: 'no longer active',
        notIncludedTitle: 'What is not included',
        notIncluded: 'Secrets (passwords, PINs, pairing codes and tablet credentials), technical logs and temporary copies of answers from other services. The photos and recordings themselves are not included; when they were made and their size are.',
        rightsTitle: 'Your rights',
        rights: 'You can correct data in the app itself, remove someone from the family or delete the whole family board under Settings › Your data. Questions or a complaint? Contact AMUMIN (see the privacy statement in the app); you may also complain to the Dutch Data Protection Authority (Autoriteit Persoonsgegevens).',
        accountTitle: 'Your account',
        accountBody: 'The e-mail address you log in with and when your account was created (account.json).',
        domains: {
            household: {
                title: 'Family and tablets',
                body: 'The family board with the household type, members, logins (without passwords) and their screen choices, rooms, tablets, invitations and the rough location.',
            },
            profile: {
                title: 'What suits our family',
                body: 'Cuisine, faith, food and special days, with all consents (also withdrawn ones).',
            },
            calendar: {
                title: 'Calendar',
                body: 'Events, repeats, who comes along, rides, reminders and linked calendars.',
            },
            tasks: {
                title: 'Tasks and rewards',
                body: 'Tasks, who did them, points, rewards and requests.',
            },
            food: { title: 'Food', body: 'Shopping, recipes, week menu and pantry.' },
            // Golf 8 (0049): Kosten delen.
            costs: {
                title: 'Split costs',
                body: 'Expenses with their split, settlements and closed periods of the house.',
            },
            family: {
                title: 'Family and messages',
                body: 'Wish lists, contacts, linked families, conversations and messages.',
            },
            rooms: {
                title: 'Rooms and cleaning',
                body: 'Who sleeps in which room, chores, the chore rota (away and swaps), the cleaning log and kid locks (without the code).',
            },
            media: {
                title: 'Photos and recordings',
                body: 'Details about photos and recordings: kind, size and date.',
            },
            care: {
                title: 'Check-in and family circle',
                body: "When 'All good' was tapped, notices and who got them, pauses, the circle with its rights and the consents of the older person.",
            },
            weather_prayer: {
                title: 'Weather and prayer times',
                body: 'Settings for the weather advice and the prayer times.',
            },
            growth: { title: 'Growth', body: 'Height and weight with the consents, if you use this.' },
            school: { title: 'School', body: 'Subjects and results, if you use this.' },
            security: {
                title: 'Security',
                body: 'Trusted networks, security notices and the audit log (who did what, without content).',
            },
            privacy: {
                title: 'Privacy requests',
                body: 'Downloads like this one, who was removed from the family and a scheduled deletion.',
            },
            billing: {
                title: 'Subscription and invoices',
                body: 'Your subscription and trial month, what changed (cancelling, paying) and the invoices. We keep invoices for 7 years, also after deletion (legal duty).',
            },
            // 0068: Gezond op gewicht (persoonlijk).
            kompas: {
                title: 'Healthy weight',
                body: 'Only your own: your consent, profile and goal, what you ate, water, movement, weigh-ins and your tile on the board. Kept in your own space; nobody else sees it.',
            },
            // 0069: Geldzaken (alleen in de eigen omgeving van een volwassene).
            money: {
                title: 'Money',
                body: 'Your own spaces, transactions (another person’s IBAN masked), rules, goals and holdings. Only in the download of your own space.',
            },
        },
    },
};
//# sourceMappingURL=privacyRights.en.js.map